module.exports = __webpack_public_path__ + "static/img/check.c74765ce.svg";